import React from 'react';
import {Button, Stack, Typography} from '@mui/material';

import {AlertInfo, IconIllustration, Modal} from 'presentation/components';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {formatDateString} from 'presentation/utils';

import type {OlderBillsModalProps} from './types';
import {textHandle} from 'presentation/utils/textHandle';

const {olderInvoicesModal} = translations['pt-br'].privateFlow.myFinancial.openBills;

function getMonth(referencia: string): string {
	return textHandle(
		formatDateString(referencia, 'dd/MM/yyyy', 'MMMM/yyyy').split('/')[0],
	).capitalize();
}

export function OlderBillsModal({
	open,
	onClose,
	numberOfOverdueBills,
	currentBill,
	onGoToOldestBill,
	onContinueWithCurrent,
	continueButtonLabel,
}: OlderBillsModalProps) {
	const isSingular = numberOfOverdueBills === 1;

	return (
		<Modal.Root open={open} onClose={onClose}>
			<Modal.Header title={olderInvoicesModal.title} onClose={onClose} />
			<Modal.Content>
				<Stack gap={2} alignItems="center">
					<IconIllustration customIconName="info-filled" variant="info" />
					<Typography variant="h6">
						{isSingular
							? olderInvoicesModal.headerTitle.singular
							: olderInvoicesModal.headerTitle.plural}
					</Typography>
					<Typography variant="body1" textAlign="center">
						{isSingular
							? olderInvoicesModal.description.singular
							: olderInvoicesModal.description.plural}
					</Typography>
					<AlertInfo.Root severity="warning" icon={<Icon name="warning-outlined" />}>
						<AlertInfo.Description>
							<Typography variant="body2">
								{olderInvoicesModal.alertMessage}
							</Typography>
						</AlertInfo.Description>
					</AlertInfo.Root>
				</Stack>
			</Modal.Content>
			<Modal.Footer>
				<Stack width="100%" gap={1}>
					{numberOfOverdueBills > 0 ? (
						<Button variant="contained" fullWidth onClick={onGoToOldestBill}>
							{olderInvoicesModal.regularizeNow}
						</Button>
					) : null}
					{currentBill ? (
						<Button
							variant="outlined"
							fullWidth
							onClick={() => onContinueWithCurrent(currentBill)}>
							{continueButtonLabel ??
								olderInvoicesModal.buttonContinue.replace(
									'{month}',
									getMonth(currentBill.dtVencimento),
								)}
						</Button>
					) : null}
				</Stack>
			</Modal.Footer>
		</Modal.Root>
	);
}
